import { z } from 'zod/v4';

import { mobileInstructionStatusTypeSchema } from './mobile-instruction-status-type.schema';

export const mobileInstructionStatusSchema = z.object({
  id: z.number().min(0),
  instructionId: z.number().min(0),
  assetId: z.string().min(1).nullable().optional(),
  accountId: z.number().min(0).optional(),
  status: mobileInstructionStatusTypeSchema,
  detail: z.string().min(1).nullable(),
  timestamp: z.string(),
  deviceId: z.string(),
});

export type MobileInstructionStatus = z.infer<
  typeof mobileInstructionStatusSchema
>;
